import React from 'react';
import TwoSidedDocumentUploadScreen from './TwoSidedDocumentUploadScreen';

export default function InsuranceDocumentUploadScreen(props) {
  return (
    <TwoSidedDocumentUploadScreen
      {...props}
      routeName="insurance_doc_upload"
      previousRoute="technical_inspection_doc_upload"
      nextRoute="document_upload_completion_screen"
      docType="INSURANCE"
      docKey="insurance"
      skipFlag="insuranceSkipped"
      title="Assurance quatrième catégorie A"
      subtitle="Ajoutez le recto et le verso de l’assurance, ou importez un PDF complet."
    />
  );
}